export enum TeamFilterType {
  JustMe = 'Just Me',
  Team = 'Team',
  Agent = 'Agent',
}
